// import { AdobeAn } from './resultImage/lib';
import { AdobeAn } from './resultImage/share-image-template';
import { dataURLtoBlob } from '../../vendors/ngblib/utils/dataURLtoBlob';

const createjs = require('createjs/builds/1.0.0/createjs');

class ResultImageGenerator {
    #canvas;
    #stage;
    #root;
    #score = 0;
    #textId = 'text-1';

    constructor(jsImagesStoreArr) {
        this.#canvas = document.getElementById('share-result-canvas');

        const comp = AdobeAn.getComposition('6A0C9D3AEEF347F6BB054ED130C28BA3');
        const lib = comp.getLibrary();
        const images = comp.getImages();
        const ss = comp.getSpriteSheet();
        const { ssMetadata, properties } = lib;
        const { manifest } = properties;

        // Pass images to the lib
        manifest.forEach(({ id }) => {
            const loaded = jsImagesStoreArr[id];

            if (!loaded) return;

            const { image, src, error } = loaded;

            if (error) {
                // Try again
                image.src = src;
            }

            images[id] = loaded.image;
        });

        // Construct
        if (ssMetadata.length > 0) {
            for (let i = 0; i < ssMetadata.length; i += 1) {
                ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                    images: [images[ssMetadata[i].name]],
                    frames: ssMetadata[i].frames
                });
            }
        }
        // eslint-disable-next-line
        const root = new lib.shareimagetemplate();
        const stage = new lib.Stage(this.#canvas);

        stage.addChild(root);

        AdobeAn.compositionLoaded(lib.properties.id);

        // RENDER
        // Initiate internal method:
        stage.update();

        console.log(root);

        // update
        root.setResult(this.#score, this.#textId);

        stage.update();

        this.#root = root;
        this.#stage = stage;
    }

    set value(data) {
        this.#score = data.score;
        const { levelsCompleted = 0 } = data;

        switch (levelsCompleted) {
            case 0:
                this.#textId = 'text-1';

                break;
            case 1:
                this.#textId = 'text-2';

                break;
            case 2:
                this.#textId = 'text-3';

                break;
            default: this.#textId = 'text-4';
        }

        this.#root.setResult(this.#score, this.#textId);
        this.#stage.update();
    }

    get value() {
        return { score: this.#score, textId: this.#textId };
    }

    getBlob() {
        return dataURLtoBlob(this.#canvas.toDataURL());
    }

    toBlob(callback) {
        this.#canvas.toBlob(
            callback,
            'image/png',
            1
        );
    }
}

let instance = null;

export const getResultImageGenerator = (jsImagesStoreArr) => {
    instance = instance || new ResultImageGenerator(jsImagesStoreArr);

    return instance;
};
